import { BaseService } from '../base';

export type BusinessActivity = {
  code: number;
  description: string;
};

export type BusinessActivitiesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type BusinessActivitiesResponse = {
  data: BusinessActivity[];
  meta: BusinessActivitiesMeta;
};

export type GetBusinessActivitiesParams = {
  filter?: string;
  pageNumber?: number;
  pageSize?: number;
};

export class BusinessActivitiesService extends BaseService {
  async getBusinessActivities(
    params: GetBusinessActivitiesParams = {}
  ): Promise<{
    success: boolean;
    data?: BusinessActivitiesResponse;
    error?: string;
  }> {
    try {
      const { filter, pageNumber = 1, pageSize = 1000 } = params;

      const queryParams = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
      });

      const trimmedFilter = filter?.trim();
      if (trimmedFilter) {
        queryParams.set('filter', trimmedFilter);
      }

      const path = `/portal/v1/products/business-activities?${queryParams.toString()}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<BusinessActivitiesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar atividades empresariais',
      };
    }
  }
}

export const businessActivitiesService = new BusinessActivitiesService();
